// extracted by mini-css-extract-plugin
export var dropdown = "_sz-0";
export var imageWrapper = "_sz-3";
export var itemNameContainer = "_sz-1";
export var productImage = "_sz-2";
export var spinnerWrapper = "_sz-4";